(function () {
  'use strict';

  // Teeinblue adds and validates the personalized item; Yuva renders the cart.
  var campaign = window.teeinblueCampaign || window.TeeInBlueCampaign;
  var cartButton = document.querySelector('.openCartDrawer');
  if (!campaign || !campaign.config || !cartButton) return;

  campaign.config.atc_action = 'stay';
  if (campaign.configTranslation) campaign.configTranslation.atc_action = 'stay';
  var options = window.teeinblue = window.teeinblue || {};
  var previousOnItemAdded = options.onItemAdded;
  options.gotoCart = false;
  options.onItemAdded = function (item) {
    if (typeof previousOnItemAdded === 'function') previousOnItemAdded(item);
    if (typeof window.openCartDrawer === 'function' && window.jQuery) {
      window.openCartDrawer(window.jQuery(document.getElementById('teeAtcButton') || cartButton));
    } else {
      window.location.assign((window.Shopify.routes.root || '/') + 'cart');
    }
  };
})();
